


import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SelfImprovementOutlinedIcon from "@mui/icons-material/SelfImprovementOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';

import ListIcon from "@mui/icons-material/List";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined"; 
import FilterListIcon from "@mui/icons-material/FilterListOutlined"; 

import { useUser } from "../../common/UserContext";

import LogOffIcon from "@mui/icons-material/LogoutOutlined"; 

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isCollapsed, setIsCollapsed] = useState(isMobile);
  const [selected, setSelected] = useState("Dashboard");

  const { appUserFirstName, appUserLastName, appUserRole } = useUser();

  const navigate = useNavigate();

/*  B E G I N    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */
    useEffect(() => {
      
    // Function to update the height

      const timer = setTimeout(() => {
      //  alert(`Selected: ${selected}`);

        const totalHeight = 100;
      setBoxHeight(totalHeight + 'hv');

      }, 1000); // Delay the alert by 10 seconds
     
      return () => clearTimeout(timer); // Clean up the timer when the component unmounts or before the next effect runs

    }, [selected]); // This effect depends on 'selected' and runs when it changes

  /*  E N D    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */

    
/*    B E G I N    C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  
const [boxHeight, setBoxHeight] = useState('auto');

useEffect(() => {
  // Function to update the height
  const updateHeight = () => {

    // Set the height to the total scrollable height of the document
    const totalHeight = document.documentElement.scrollHeight;
    setBoxHeight(totalHeight + 'px');
  };

   // Instantiate and configure MutationObserver
   const observer = new MutationObserver(mutations => {
    updateHeight();
  });

  // Start observing the body for DOM changes
  observer.observe(document.body, {
    childList: true,      // Observe direct children changes
    subtree: true,        // Observe all descendants
    attributes: true,     // Observe attributes changes
    characterData: true   // Observe text changes
  });

  // Update the height initially and on window resize
  updateHeight();
  window.addEventListener('resize', updateHeight);

  // Cleanup listener when component unmounts
  return () => {
    window.removeEventListener('resize', updateHeight);
    observer.disconnect();
  };
}, []);

/*    E N D     C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  

  return (

    <Box
    sx={{...(!isCollapsed ? { minWidth: '370px' } : {}),
      height: boxHeight, // Apply the dynamic height
      borderRight: "1px solid #5d5d5d",
      "& .pro-sidebar-inner": {
        background: `${colors.primary[600]} !important`,
      },
      "& .pro-icon-wrapper": {
        backgroundColor: "transparent !important",
      },
      "& .pro-inner-item": {
        padding: "5px 35px 5px 20px !important",
      },
      "& .pro-inner-item:hover": {
        color: "#868dfb !important",
      },
      "& .pro-menu-item.active": {
        color: "#6870fa !important",
      },
    }}
  >
    <ProSidebar collapsed={isCollapsed} style={isMobile ? {} : {...(!isCollapsed ? { width: '100%' } : {})}}>
      <Menu iconShape="square">
        {/* LOGO AND MENU ICON */}

        {!isMobile && 
        <MenuItem
          onClick={() => setIsCollapsed(!isCollapsed)}
          icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
          style={{
            margin: "10px 0 20px 0",
            color: colors.grey[100],
          }}
        >
          {!isCollapsed && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              ml="15px"
            >
              <Typography variant="h3" color={colors.grey[100]}> 
                 {/* ADMINIS */}
              </Typography>
              <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>
          )}
        </MenuItem>
        }

        {!isCollapsed && (
          <Box mb="25px">
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                alt="profile-user"
                width="100px"
                height="100px"
                src={`../../assets/logo.png`}
                style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              />
            </Box>
            <Box textAlign="center">
              <Typography
                variant="h3"
                sx={{ m: "10px 0 0 0" }} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              >
               Guidyly
              </Typography>
              <Typography variant="h5" color={colors.greenAccent[500]} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}>
                Coach Service Platform
              </Typography>
            </Box>
          </Box>
        )}

        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
          <Item
            title="Dashboard"
            to="/app"
            icon={<HomeOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          <Tooltip title="These are the foundational records your account needs to function smoothly." arrow 
           PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
              sx: {
                '& .MuiTooltip-tooltip': {
                  fontSize: '16px',
                  padding: '8px 12px', // optional, for better readability
                },
              },
            }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Essentials
            </Typography>
          </Tooltip>

          
                <Item
                title="Skills"
                to="/skills"
                icon={<SelfImprovementOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Coaches"
                to="/coaches"
                icon={<PersonOutlineOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Training Program Builder"
                to="/trainingprogrambuilder"
                icon={<PlaylistAddCheckOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Content Library"
                to="/contentlibrary"
                icon={<LibraryBooksOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Clients"
                to="/clients"
                icon={<PeopleOutlineOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            

          <Tooltip title="These are the day-to-day records you’ll create and manage as part of running your organization." arrow 
           PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
            sx: {
              '& .MuiTooltip-tooltip': {
                fontSize: '16px',
                padding: '8px 12px', // optional, for better readability
              },
            },
          }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              {isCollapsed ? 'Daily' : 'Daily Activities'}

            </Typography>
          </Tooltip>

          
  
              {!isMobile &&
                  <SubMenu
                    title="Coaching Sessions"
                  to="/coachingsessions"
                    icon={<EventNoteOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Coaching Session"))
                      {
                        setSelected("Coaching Session List");
                        navigate("/coachingsessions/list");
                      }
                    }}
                  >
                    <Item
                      title="Coaching Session List"
                      to="/coachingsessions/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Coaching Sessions by Status"
                      to="/coachingsessions/status"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Coaching Sessions by Frequency"
                to="/coachingsessions/frequency"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Coaching Sessions"
                  to="/coachingsessions"
                  icon={<EventNoteOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Tasks"
                  to="/tasks"
                    icon={<AssignmentTurnedInOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Task"))
                      {
                        setSelected("Task List");
                        navigate("/tasks/list");
                      }
                    }}
                  >
                    <Item
                      title="Task List"
                      to="/tasks/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Tasks by Status"
                      to="/tasks/status"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Tasks by Priority"
                to="/tasks/priority"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Tasks"
                  to="/tasks"
                  icon={<AssignmentTurnedInOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Goal Setting And Tracking"
                  to="/goalsettingandtracking"
                    icon={<FlagOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Goal Setting And Tracking"))
                      {
                        setSelected("Goal Setting And Tracking List");
                        navigate("/goalsettingandtracking/list");
                      }
                    }}
                  >
                    <Item
                      title="Goal Setting And Tracking List"
                      to="/goalsettingandtracking/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Goal Setting And Tracking by Status"
                      to="/goalsettingandtracking/status"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Goal Setting And Tracking by Priority"
                to="/goalsettingandtracking/priority"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Goal Setting And Tracking"
                  to="/goalsettingandtracking"
                  icon={<FlagOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
                  <Item
                  title="Coach Performance Tracking"
                  to="/coachperformancetracking"
                  icon={<TrendingUpOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Billing"
                  to="/billing"
                    icon={<RequestQuoteOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Billing"))
                      {
                        setSelected("Billing List");
                        navigate("/billing/list");
                      }
                    }}
                  >
                    <Item
                      title="Billing List"
                      to="/billing/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Billing by Payment Status"
                      to="/billing/paymentstatus"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Billing by Payment Method"
                to="/billing/paymentmethod"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Billing"
                  to="/billing"
                  icon={<RequestQuoteOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
     
       {/*
           
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >

            Pages
          </Typography>
          <Item
            title="Calendar"
            to="/calendar"
            icon={<CalendarTodayOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
     
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Charts
          </Typography>
          <Item
            title="Bar Chart"
            to="/bar"
            icon={<BarChartOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Pie Chart"
            to="/pie"
            icon={<PieChartOutlineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Line Chart"
            to="/line"
            icon={<TimelineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Geography Chart"
            to="/geography"
            icon={<MapOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          */}

          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Account
          </Typography>

          {appUserRole === "admin" && (
          <Item
            title="Subscriptions"
            to="/subscriptions"
            icon={<SubscriptionsOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}

          {appUserRole === "admin" && (
            <Item
              title="User Accounts"
              to="/useraccounts"
              icon={<ManageAccountsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          )}

          <Item
            title="Log Out"
            to="/logout"
            icon={<LogOffIcon />}
            selected={selected}
            setSelected={setSelected}
          />

        </Box>
      </Menu>
    </ProSidebar>
  </Box>

  );
};

export default Sidebar;
